import api, { GetApiReturn, handleApiError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindSetorDto } from '@/api.types.extra';
import { ReadSetorDto, UpdateSetorDto } from '@/api.types';

export async function GetSetores(filters: FindSetorDto) {
  try {
    if (filters) {
      filters.skip ??= 0;
      filters.take ??= 10;
    }

    const response = await api.get(Endpoints.SETORES, { params: filters });
    return GetApiReturn<ReadSetorDto>(response.data as any);
  } catch (error) {
    handleApiError(error);
  }
}

export async function GetSetoresByUnidade(unidadeId: number) {
  try {
    const params = new URLSearchParams();
    params.append('predio_id', unidadeId.toString());
    params.append('comDefensorias', 'true');
    params.append('comResponsavel', 'true');
    params.append('comPredio', 'true');

    const response = await api.get(`${Endpoints.SETORES}?${params.toString()}`);
    return GetApiReturn<ReadSetorDto>(response.data as any);
  } catch (error) {
    handleApiError(error);
  }
}

export async function GetSetor(id: number) {
  try {
    const params = new URLSearchParams();
    params.append('id', id.toString());
    params.append('comDefensorias', 'true');
    params.append('comResponsavel', 'true');
    params.append('comPredio', 'true');
    params.append('comPai', 'true');

    const response = await api.get(`${Endpoints.SETORES}?${params.toString()}`);
    const data = response.data[0] as Array<ReadSetorDto>;
    return data && data.length > 0 ? data[0] : null;
  } catch (error) {
    handleApiError(error);
  }
}

export async function SetSetor(setor: Partial<UpdateSetorDto> & { id?: number; nome: string }) {
  if (setor.id !== null && setor.id != undefined && setor.id > 0) {
    return api
      .put(Endpoints.SETORES, setor)
      .then(() => {
        return 'Setor ' + setor.nome + ' atualizado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(error, 'Falha ao atualizar o Setor.');
      });
  } else {
    return api
      .post(Endpoints.SETORES, setor)
      .then(() => {
        return 'Setor ' + setor.nome + ' cadastrado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(error, 'Falha ao cadastrar o Setor.');
      });
  }
}

export async function DeleteSetor(id: number) {
  return api
    .delete(`${Endpoints.SETORES}/${id}`)
    .then(() => {
      return 'Setor removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover Setor.');
    });
}

